import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Typography } from 'antd'

const { TextArea } = Input
const { Text } = Typography

/**
 * baseProps 契约：
 * - record：当前预警记录（展示摘要等，表单提交不依赖）
 */
class MarkMonitoringLogFalsePositiveForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    baseProps: PropTypes.object
  }

  static defaultProps = {
    baseProps: {}
  }

  render () {
    const { form, baseProps } = this.props
    const { record } = baseProps || {}
    const summary = record?.summary != null && record.summary !== ''
      ? String(record.summary).trim()
      : ''

    return (
      <Form ref={form} layout="vertical">
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          表示这条推送识别有误，便于后续优化。误判说明选填。
        </Text>
        {summary ? (
          <Form.Item label="摘要">
            <Text>{summary}</Text>
          </Form.Item>
        ) : null}
        <Form.Item
          label="误判说明"
          name="falsePositiveReason"
          rules={[{ max: 500, message: '说明不能超过500个字符' }]}
        >
          <TextArea
            rows={4}
            placeholder="选填，说明为何判定为误报"
            allowClear
            showCount
            maxLength={500}
          />
        </Form.Item>
      </Form>
    )
  }
}

export default MarkMonitoringLogFalsePositiveForm
